export { default } from './PreguntesFrequents';
